/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/tables";
import MyTickets from "layouts/tables/tickets/myTickets";

import TvsCombined from "layouts/tables/documents/tvsCombined";
import Tvs from "layouts/tables/documents/tvs";

import Documents from "layouts/tables/documents/documents";

import Users from "layouts/tables/user/users";

import Messages from "layouts/tables/tickets/messages";

import SignOut from "layouts/authentication/sign-out";

import Settings from "layouts/tables/user/profile";

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    role: ["user"],
    type: "collapse",
    name: "New Ticket",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    role: ["admin", "agent", "tech"],
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    role: ["user"],

    type: "collapse",
    name: "Tickets",
    key: "tickets",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/tickets",
    component: <MyTickets />,
  },
  {
    role: ["agent", "admin", "tech"],
    
    type: "collapse",
    name: "Tickets",
    key: "tickets",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/tickets",
    component: <MyTickets all={true} />,
  },
  {
    hidden: true,

    route: "/tickets/:id",
    component: <Messages />,
  },
  {
    role: ["tech", "user"],
    
    type: "collapse",
    name: "Documents & Softwares",
    key: "document_tvs",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/document_tvs",
    component: <TvsCombined />,
  },

  {
    role: ["tech"],
    type: "divider",
  },
  {
    role: ["tech"],
    
    type: "collapse",
    name: "Televisions",
    key: "tvs",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/tvs",
    component: <Tvs />,
  },
  {
    role: ["tech"],
    
    type: "collapse",
    name: "Documents",
    key: "docs",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/docs",
    component: <Documents />,
  },

  {
    role: ["admin"],
    type: "divider",
  },

  {
    role: ["admin"],
    
    type: "collapse",
    name: "Clients Management",
    key: "clients",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/clients",
    component: <Users />,
  },

  {
    type: "divider",
  },

  {
    type: "collapse",
    name: "Settings",
    key: "settings",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/settings",
    component: <Settings />,
  },
  {
    type: "collapse",
    name: "Sign Out",
    key: "sign-Out",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/logout",
    component: <SignOut />,
  }
];

export default routes;
